module.exports = __webpack_public_path__ + "assets/img/fingerprint.525850b1.svg";